export default __webpack_public_path__ + "static/media/PRA_Walk_step1.f583f1c5.wav";